import { Input } from '@nextui-org/react'
import React, { useState } from 'react'
import { useFormContext } from '../Context/FormContext';

const InputBox = ({type, radius, label, placement, defaultValue, icon, mandatory, register, name, error, maxLength}) => {

  const { formData, updateFormData } = useFormContext();

  return (
    <Input
        {...register(`${name}`)}
        name={name}
        defaultValue={defaultValue}
        type={type}
        radius={radius}
        label={<div>{label}<span className='text-[red]'>{mandatory && "*"}</span></div>}
        placeholder={label}
        startContent={icon && <i className={icon}></i>}
        labelPlacement={placement}
        maxLength={maxLength}
        errorMessage={<span className='text-[red]'>{error && error[name] && error[name]?.message}</span>}
    />
  )
}

export default InputBox